import React from 'react';

const InfoRow = ({ label, value, children }) => {
    return (
        <div className="row mb-3">
            <label className="col-lg-4 fw-bold text-muted fs-6">{label}</label>
            <div className="col-lg-8">
                <span className="fw-bolder fs-6 text-gray-800">{value || children}</span>
            </div>
        </div>
    );
};

export default InfoRow;
